import React from 'react';
import { Form, Input } from 'antd';

const AdminName: React.FC = () => {
  return (
    <Form.Item
      name="name"
      label="Name"
      rules={[{ required: true, message: 'Please enter the name!' }]}
    >
      <Input />
    </Form.Item>
  );
};

export default AdminName;
